module.exports = __webpack_public_path__ + "img/dynamics-crm.745e4cbf.png";